import React from "react";
import UserContext from "./UserContext";

import { ApiHelper } from "./components";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Login } from "./Login";

import { Authenticated } from "./Authenticated";
import { Logout } from "./Logout";
import ReactGA from "react-ga4";
import { EnvironmentHelper } from "./helpers";
import { Home } from "./Home";

export const ControlPanel = () => {
  const location = useLocation();
  if (EnvironmentHelper.Common.GoogleAnalyticsTag !== "") {
    ReactGA.initialize(EnvironmentHelper.Common.GoogleAnalyticsTag);
    ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search });
  }
  React.useEffect(() => {
    if (EnvironmentHelper.Common.GoogleAnalyticsTag !== "") {
      ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
    }
  }, [location]);

  React.useContext(UserContext); //to force rerender on login
  return (
    <Routes>
      <Route path="/logout" element={<Logout />} />
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<Home />} />
      <Route
        path="/*"
        element={
          <RequireAuth>
            <Authenticated />
          </RequireAuth>
        }
      />
    </Routes>
  );
};

const RequireAuth = ({ children }: { children: React.ReactElement }) => {
  const location = useLocation();
  if (!ApiHelper.isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};
